import React, { FC } from "react";

import { SanitizeHtml, withSuspense } from "@keepeek/refront-components";
import { Box, Skeleton } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import sanitizeHtml from "sanitize-html";

import { TranslationSchema } from "../../../models/configuration/components/basketsWidget";
import { useCurrentLocale } from "../../../providers/i18n/hooks";
import { useBasketsWidget } from "./hooks";

export type BasketsTotalCountProps = {
  widgetId: string;
  queryFilter: string;
  title?: TranslationSchema[];
};

const BasketsTotalCount: FC<BasketsTotalCountProps> = function ({ widgetId, queryFilter, title }) {
  const { t } = useTranslation();
  const currentLocale = useCurrentLocale();

  const { basketList } = useBasketsWidget({ widgetId, queryFilter });
  const currentTitle = title?.find((t) => t.language === currentLocale) ?? {
    value: t("basketWidget.title.default.label", { count: basketList?.totalCount ?? 0 }),
    empty: false,
  };
  return (
    <>
      {currentTitle && !currentTitle.empty && (
        <Box textAlign="center" className={clsx("BasketsWidget-totalCount")}>
          <SanitizeHtml
            html={currentTitle.value ?? ""}
            sanitizeOptions={{
              allowedAttributes: {
                ...sanitizeHtml.defaults.allowedAttributes,
                span: ["style"],
              },
            }}
          />
        </Box>
      )}
    </>
  );
};

const LoadingBasketsTotalCount = function () {
  return (
    <Box
      sx={{
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
      display="flex"
    >
      <h1>
        <Skeleton animation="wave" width={200} />
      </h1>
    </Box>
  );
};

export default withSuspense(BasketsTotalCount, {
  LoadingComponent: LoadingBasketsTotalCount,
});
